import axios from "axios";
import { logout } from "../utils/auth"; 

export const API_BASE_URL = window.env?.REACT_APP_API || process.env.REACT_APP_API || 'http://localhost:4000/api';

const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const path = window.location.pathname;
    
    if (status === 401 || status === 403) {
        
        if (path.includes('/login')) {
            return Promise.reject(error);
        }

        console.warn(`⛔ Acesso negado em ${path}. Token inválido ou expirado.`);
        
        logout(); 

        if (path.includes('/obs') || path.includes('/painelsessao')) {
            window.location.href = `${path}?expired=true`;
        } else {
            window.location.href = "/login?expired=true";
        }
    }
    
    return Promise.reject(error);
  }
);

export default axiosInstance;